import { utilFunctionService } from "@/utils/utils.service"
export default function isLoggedin ({ next }){
    if (utilFunctionService.getLocalStorageService("instructor")) {
        return next('active')
      }
    return next()
   }
